<template>
  <div class="dialog-body">
    <el-dialog
      v-if="dialogVisible"
      title="仓单手动冻结提示"
      align="center"
      :visible.sync="dialogVisible"
      append-to-body
      width="50%"
      ref="dialogRef"
    >
      <div class="result">
        <el-row :gutter="24">
          <el-col :span="24">
            <span style="text-align: center; display: block">是否提交仓单手动冻结申请</span>
          </el-col>
        </el-row>
        <el-form :model="form" :rules="rules" ref="freezeRef" label-width="120px">
          <el-form-item label="仓单冻结原因" prop="frozeReason">
            <el-select v-model="form.frozeReason" placeholder="请选择冻结原因" style="width: 100%">
              <el-option label="客户原因" value="0"></el-option>
              <el-option label="公司原因" value="1"></el-option>
              <el-option label="货物价值原因" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" v-model="form.remark"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <FileTable ref="fileTableRef" :isShowDownBtn="isShowDownBtn" :attachments="attachments" />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSure">确认申请</el-button>
        <el-button @click="handleClose">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import superviseBillApi from '@/api/park/superviseBill';
  import FileTable from '@/components/business/FileTable/index.vue';
  import XEUtils from 'xe-utils';
  export default {
    name: 'FreezeDialog',
    props: ['selectData'],
    data() {
      return {
        dialogVisible: false,
        form: {
          frozeReason: null,
          remark: '',
          id: null,
        },
        formLabelWidth: '110px',
        tableData: [],
        attachments: [],
        isShowDownBtn: false,
        loading: false,
        text: '上传附件',
        rules: {
          frozeReason: [{ required: true, message: '冻结原因必填', trigger: ['change', 'blur'] }],
        },
      };
    },
    methods: {
      // 打开弹窗
      openDialog() {
        this.dialogVisible = true;
      },
      // 关闭弹窗
      handleClose() {
        this.dialogVisible = false;
      },
      // 确认申请
      async handleSure() {
        const $table = this.$refs.freezeRef;
        // 1.表单数据
        const baseFormData = this.form;
        // 2.附件
        const attachments = this.attachments;
        const postData = {
          ...baseFormData,
          attachments,
          companyCode: this.userInfo.companyCode,
          departmentCode: this.userInfo.departmentCode,
        };
        console.log(postData, 'postData');
        $table.validate(async (valid) => {
          if (valid) {
            const { data } = await this.$axios.post(superviseBillApi.BILL_FROZE, postData);
            if (data.code == 0) {
              this.$message.success('提交成功，请等待审批');
              this.dialogVisible = false;
              location.reload();
            } else {
              this.$message.error(data.msg);
            }
          } else {
            this.$message.error('请输入必填内容');
          }
        });
      },
      //表格日期回显
      formatDate(value, format) {
        return XEUtils.toDateString(value, format);
      },
    },
    comments: {
      FileTable,
    },
    watch: {
      selectData: {
        handler(val) {
          this.selectData = val;
          this.form.id = val.id;
          console.log(this.selectData);
        },
        immediate: false,
      },
    },
  };
</script>

<style scoped>
  ::v-deep .el-dialog__footer {
    text-align: center;
  }

  .el-dialog .el-dialog__body {
    justify-content: center;
    align-items: center;
  }
  .sirui-table {
    width: 450px;
    margin-top: -20px;
  }
  .dialog-body {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  .el-select {
    width: 320px;
  }
  .el-form {
    margin-top: 15px;
  }
  .result {
    padding: 20px 100px 20px 100px;
  }

  ::v-deep .el-dialog__footer {
    text-align: center;
  }
</style>
